<template>
    <div class="add-linkman">
        <van-nav-bar title="通讯录" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage"  />
        <div class="linkman-box">
            <div class="linkman-option">
                <p>名称</p>
                <van-field
                v-model="nameValue"
                placeholder="请输入名称"
                :border="false"
                />
            </div>
            <div class="linkman-option">
                <p>联系号码</p>
                <van-field
                v-model="iphoneValue"
                placeholder="请输入手机号"
                :border="false"
                type="number"
                :maxlength="11"
                />
            </div>
            </div>
            <div class="btn-box">
            <van-button round type="info" @click="addLinkman">{{isDelete?'确认':'添加'}}</van-button>
            <div v-if="isDelete" class="btn-text" @click="deleteLinkman">
                删除此联系人
            </div>
        </div>
  </div>
</template>

<script>
export default {
    data () {
        return {    
        nameValue:'',//名称
        iphoneValue:'',//电话号码
        isDelete:false,//是否显示删除
        deleteIndex:null,//删除名单索引
        }
    },
    created() {
        if (this.$route.query.data) {
            let data = JSON.parse(this.$route.query.data);
            this.nameValue = ''
            this.iphoneValue = ''
            this.deleteIndex = data.index
            if(data.sim){
            this.isDelete = true
            this.nameValue = data.name
            this.iphoneValue = data.sim
            }else{
            this.isDelete = false
            }
        }
    },
    methods: {
        /**
         * 添加白名单
         */
        addLinkman(){
            if(this.nameValue.trim()==""){
                this.$toast("名称不能为空")
                return
            }
            if(this.iphoneValue.trim()==""){
                this.$toast("号码不能为空！")
                return
            }
        
        let data = null;
        if(this.isDelete){
            data = {
            ver:1,
            method:'updateInstructParams',
            params:this.nameValue+','+this.iphoneValue,
            instructionId:this.$intfilter.instructFilter('白名单'),
            index:this.deleteIndex
            }
        }else{
            data = {
            ver:1,
            method:'sendInstruct',
            imei:this.imei,
            params:this.nameValue+','+this.iphoneValue,
            instructionId:this.$intfilter.instructFilter('白名单'),
            }
        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.$toast({
                    message: this.isDelete?"修改成功":"添加成功",
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/correct.png'),
                });
                this.$router.back(-1);
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        },
        /**
         * 删除通讯人
         */
        deleteLinkman(){
        this.$dialog.confirm({
            title: '提示',
            message: '确认是否删除？',
        })
            .then(() => {
            let data = {
                ver:1,
                method:'deleteInstructParams',
                params:this.nameValue+','+this.iphoneValue,
                instructionId:this.$intfilter.instructFilter('白名单'),
                index:this.deleteIndex
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
                if (res.code === 0) {
                    this.$toast({
                        message: '删除成功',
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/correct.png'),
                    });
                    this.$router.back(-1);
                } else {
                    this.$toast({
                        message: res.msg,
                        duration: 2000,
                        icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
            })
            .catch(() => {
            // on cancel
            });
        },
        /**
         * 返回上一次路由
         */
        backPage() {
            this.$router.back(-1);
        },
    }
};
</script>

<style lang="scss" scoped>
.add-linkman{
  background: #f8f8f8;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding-top: 100px;
}
.linkman-box{
  margin-top: 40px;
  width: 690px;
  height: 202px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.linkman-option{
  display: flex;
  align-items: center;
}
.linkman-option>p{
  width: 150px;
  margin-left: 32px;
  font-size: 30px;
  font-weight: 600;
  color: #666666;
}
.linkman-option>div{
  flex: 1;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
.btn-text{
  font-size: 28px;
  font-weight: 400;
  color: #FC4D56;
  margin-top: 48px;
}
</style>
<style lang="scss">
.add-linkman .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
.add-linkman ._van-field{
  flex: 1;
  color: #111111;
  font-size: 30px;
}
.add-linkman{
    .van-nav-bar{
        background-color: #F8F8F8;
    }
}
</style>